import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
import { faqs } from '../data/offer';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full border-y border-line bg-white" aria-labelledby="faq-heading" data-id="element-83" data-mp="1gd7ioekfll8n">
      <div className="mx-auto max-w-readable px-4 py-14 sm:px-5 sm:py-24" data-id="element-84" data-mp="2e0ps7rlx2rdp">
        <SectionLabel data-id="element-85" data-mp="291mkfzejy721">Frequently asked questions</SectionLabel>

        <h2 id="faq-heading" className="mt-5 font-display text-[1.75rem] font-semibold leading-tight text-ink sm:mt-6 sm:text-[2.5rem]" data-id="element-86" data-mp="2924m5bjzhdhc">
          Before you decide
        </h2>

        <div className="mt-9 divide-y divide-line border-y border-line sm:mt-12" data-id="element-87" data-mp="1z59qr1j0bt7a">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-88" data-mp="nq4n9vb1xqmm" data-mpi={index}>
                <h3 data-id="element-89" data-mp="pheje3b0vdfv">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-4 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta/40 sm:gap-6" data-id="element-90" data-mp="pizfhxczj4fu">
                    <span className="font-display text-base font-semibold leading-snug text-ink sm:text-xl" data-id="element-91" data-mp="6pdccdo3ggvd">
                      {faq.question}
                    </span>
                    <PlusIcon className={`mt-1 h-5 w-5 shrink-0 text-terracotta transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-92" data-mp="3szzdu6h340qe" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-93" data-mp="3o1eee99npl30">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-94" data-mp="1ui5r7ydq3niq">
                      <p className="pb-6 pr-1 text-sm leading-relaxed text-muted sm:pr-10 sm:text-[15px]" data-id="element-95" data-mp="2ddmckomi3p3l">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}